/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DefaultGetResult {
  Success = 0,
  Error = 1,
  TenantNotFound = 2,
  Cancelled = 3,
  Unauthenticated = 401,
  NotFound = 404,
}
